import { Components, Theme } from '@mui/material'
import { grey } from '@mui/material/colors'
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup'

const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    grouped: () => ({
      '&:not(:first-of-type)': {
        borderBottomLeftRadius: 0,
        borderLeft: 'none',
        borderTopLeftRadius: 0,
      },
      '&:not(:last-child)': {
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
      },

      border: 'none',

      borderRadius: 4,
    }),
    root: {
      // Every button is pulled a pixel left to collapse the border it shares
      // with its neighbour. MUI undoes that between two selected buttons, so
      // their borders do not double up — but these buttons have no border, so
      // the exception only makes the group a pixel wider per adjacent pair.
      [`& .${toggleButtonGroupClasses.grouped}.${toggleButtonGroupClasses.selected} + .${toggleButtonGroupClasses.grouped}.${toggleButtonGroupClasses.selected}`]:
        {
          marginLeft: -1,
        },

      background: 'white',
      border: `1px solid ${grey['300']}`,
      boxSizing: 'border-box',
      height: 32,
      padding: '3px',
    },
  },
}

export default MuiToggleButtonGroup
